// tempexp_PORTFOLIO-40783_file

import { FC, useState } from 'react';
import classNames from 'classnames';

import vacancyBenefitsShowButtonClick from '@hh.ru/analytics-js-events/build/xhh/applicant/experiments/PORTFOLIO-37970/vacancy_benefits_show_button_click';
import { Text, Title, Link, VSpacingContainer, useBreakpoint } from '@hh.ru/magritte-ui';
import { ChevronUpOutlinedSize16, ChevronDownOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { useSelector } from 'src/hooks/useSelector';

import styles from './styles.less';

const DESKTOP_COLLAPSIBLE_LIMIT = 8;
const MOBILE_COLLAPSIBLE_LIMIT = 3;

const VacancyBenefits: FC = () => {
    const vacancyId = useSelector((state) => state.vacancyView.vacancyId!);
    const benefits = useSelector((state) => state.vacancyBenefits);
    const { isMobile } = useBreakpoint();
    const [isCollapsed, setIsCollapsed] = useState(true);

    if (!benefits.length) {
        return null;
    }

    const collapsibleLimit = isMobile ? MOBILE_COLLAPSIBLE_LIMIT : DESKTOP_COLLAPSIBLE_LIMIT;
    const hasCollapsible = benefits.length > collapsibleLimit;

    return (
        <VSpacingContainer default={16}>
            <Title Element="h2" size="small">
                Преимущества вакансии
            </Title>
            <ul className={styles.benefitList}>
                {benefits.map(({ id, text }, index) => {
                    const isItemCollapsed = isCollapsed && hasCollapsible && index >= collapsibleLimit;

                    const className = classNames(styles.benefitListItem, {
                        [styles.benefitCollapsed]: isItemCollapsed,
                    });

                    return (
                        <li key={id} className={className}>
                            <Text typography="label-3-regular">{text}</Text>
                        </li>
                    );
                })}
            </ul>
            {hasCollapsible && (
                <Link
                    Element="button"
                    typography="label-2-regular"
                    iconRight={isCollapsed ? <ChevronDownOutlinedSize16 /> : <ChevronUpOutlinedSize16 />}
                    onClick={() => {
                        vacancyBenefitsShowButtonClick({
                            actionType: isCollapsed ? 'show' : 'hide',
                            vacancyId: `${vacancyId}`,
                        });
                        setIsCollapsed((collapsed) => !collapsed);
                    }}
                >
                    {isCollapsed ? 'Ещё преимущества' : 'Скрыть'}
                </Link>
            )}
        </VSpacingContainer>
    );
};

export default VacancyBenefits;
